
/* injects from baggage-loader */

'use strict';
import $ from 'jquery';
import AlertController from '../alert/alert.controller';

import { failDialg, feedbackFinishStage } from './quiz-onca.const';

import { max, min, sortBy, shuffle } from 'lodash';


export default class DialogQuizOncaController extends AlertController {
    constructor($log, $rootScope, $timeout, $state, Dialog, Trophies, Session) {
        'ngInject';
        super($log, $rootScope);
        this.$log = $log;
        this.$state = $state;
        this.$timeout = $timeout;
        this.Dialog = Dialog;
        this.Trophies = Trophies;
        this.Session = Session;

        this.carousel = null;

        this.answers = {
            q1: {
                error: null,
                value: null
            },
            q2: {
                error: null,
                value: null
            },
            q3: {
                error: null,
                value: null
            },
            q4: {
                error: null,
                value: null
            },
            q5: {
                error: null,
                value: null
            },
            q6: {
                error: null,
                value: null
            }
        }
        this.items = [];
    }
    $onInit() {
        this.$timeout(this.bindCarousel.bind(this));
        this.items = [this.resolve.model.paper, this.resolve.model.metal, this.resolve.model.glass];

        console.log(this.resolve);


        this.resolve.model = {
            paper: parseInt(this.resolve.model.paper),
            metal: parseInt(this.resolve.model.metal),
            glass: parseInt(this.resolve.model.glass)
        }

        let material = [
            { 'name': 'papel', 'qnt': this.resolve.model.paper },
            { 'name': 'metal', 'qnt': this.resolve.model.metal },
            { 'name': 'vidro', 'qnt': this.resolve.model.glass }
        ];

        this.itemSort = sortBy(material, ['qnt']);
        this.itemRandom = shuffle(material);
        this.itemsRandoms = shuffle(material);



    }

    bindCarousel() {
        $('.quiz-carousel').slick({
            infinite: false,
            draggable: false,
            dots: true,
            slidesToShow: 1,
            slidesToScroll: 1
        });
    }

    submit(form) {
        if (form.$valid) {

            this.answers.q1.error = this.q1Val();
            this.answers.q2.error = this.q2Val();
            this.answers.q3.error = this.q3Val();
            this.answers.q4.error = this.q4Val();
            this.answers.q5.error = this.q5Val();
            this.answers.q6.error = this.q6Val();

            let result = null;
            let responses = [];

            angular.forEach(this.answers, value => {
                responses.push(value.error);
            });

            result = responses.filter(error => error === true).length

            if (this.answers.q1.error || this.answers.q2.error || this.answers.q3.error) {

                $('.quiz-carousel').slick('slickGoTo', 0);
            } else {
                if (this.answers.q4.error || this.answers.q5.error || this.answers.q6.error) {
                    $('.quiz-carousel').slick('slickGoTo', 1);
                }
            }

            if (result === 0) {
                this.onQuizCorrect();
            } else {
                this.Dialog.showFeedback('label-opa', failDialg, 'btn-ok', () => false);
            }
        }
    }

    q1Val() {
        return parseInt(this.answers.q1.value) !== (this.itemsRandoms[0].qnt + this.itemsRandoms[1].qnt);
    }

    q2Val() {
        return parseInt(this.answers.q2.value) !== (this.resolve.model.paper + this.resolve.model.metal + this.resolve.model.glass);
    }

    q3Val() {
        return parseInt(this.answers.q3.value) !== (this.itemSort[2].qnt - this.itemSort[0].qnt);
    }

    q4Val() {

        return parseInt(this.answers.q4.value) !== this.itemRandom[1].qnt;
    }

    q5Val() {
        let maximo = max(this.items);

        return parseInt(this.answers.q5.value) !== parseInt(maximo);
    }

    q6Val() {
        let minimo = min(this.items)

        return parseInt(this.answers.q6.value) !== parseInt(minimo);
    }

    onQuizCorrect() {
        this.Trophies.collectThrophies('default', 'onca');
        this.Trophies.collectThrophies('emblem', 'onca');

        this.Dialog.showTrophy('onca', feedbackFinishStage, () => {
            let infos = this.Session.get();
            infos.stages[1].totalCompleted++;
            this.Session.save(infos);
            this.$state.go('main');
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/components/dialogs/quiz-onca/quiz-onca.controller.js